import React, { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@mui/material';
import { FaSave, FaTimes } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa6';
import Select from 'react-select'; // replace with actual import
import ReactSelect from 'react-select';
import us from 'assets/images/dbDummy/us.png';
import eu from 'assets/images/dbDummy/eu.png';
import gbp from 'assets/images/dbDummy/ae.png';
import { getCurrencySymbol, numberFormatter } from 'utils/currency';
import { motion, AnimatePresence} from 'framer-motion';
import { FiTrash2, FiChevronDown } from 'react-icons/fi';
import { IconArrowsExchange } from '@tabler/icons'; // replace with actual import



// ✅ Clear
const ProductsPopupMobile = ({ onClose, onSubmit, currency = 'eur', preLoadedData, orderType, setOrderType, customer, transitCompany }) => {
	const compRef = useRef(null);
	const [discount, setDiscount] = useState({
			discountType: 'percentage', // percentage, amount
			discountValue: 0
		});
	// ## To close the popup ## //
	const handleClose = () => {
		onClose && onClose();
	};


	// ## Dropdown Data ## //
	const [models, setModels] = useState([]);
	const [invoiceList, setInvoiceList] = useState([]);
	const vatTypes = [{ label: 'Including VAT', value: 1, percentage: 0 }];

	const getSelectOptions = () => {
		// Fetch Models
		api.getSelectOptionsList('product').then((res) => {
			const tempList = res.data.map((item) => ({
				...item,
				label: `${item.product_name}`,
				value: item.id
			}));
			setModels(tempList);
		});

		api.getSelectOptionsList('invoice').then((res) => {
			const tempList = res.data.map((item) => ({
				...item,
				label: item.invoice_number,
				value: item.id
			}));
			setInvoiceList(tempList);
		});
	};

	useEffect(() => {
		if (preLoadedData) {
			if (preLoadedData?.selections) {
				setModels(preLoadedData?.selections?.models);
				setInvoiceList(preLoadedData?.selections?.invoiceList);
			} else {
				getSelectOptions();
			}

			setInvItems(
				preLoadedData?.invItems?.map((item) => ({
					...item,
					model: item?.model?.value,
					invoice: item?.invoice?.id,
					vat: item?.vat?.value
				})) || []
			);
			setShippingFee(preLoadedData?.shippingFee || 0);
		} else {
			getSelectOptions();
		}
	}, []);

	// ## Invoice Data Handling ## //
	const [invItems, setInvItems] = useState([
		{
			seqId: 1,
			qty: orderType == 'credit-note' ? -1 : 1,
			model: '',
			vat: 1,
			unitPrice: 0,
			comment: '',
			commentToggle: false,
			invoice: '',
			modelOptions: [],
			modelOptionsLoading: false,
			customValue: ''
		}
	]);

	const [shippingFee, setShippingFee] = useState(0);
	const shippingQty = orderType == 'credit-note' ? -1 : 1;

	const newRowTemplate = {
		seqId: invItems?.length + 1,
		qty: orderType == 'credit-note' ? -1 : 1,
		model: '',
		vat: 1,
		unitPrice: 0,
		comment: '',
		commentToggle: false,
		invoice: '',
		modelOptions: [],
		modelOptionsLoading: false,
		customValue: ''
	};

	useEffect(() => {
		setInvItems((oldData) =>
			oldData.map((item) => ({
				...item,
				qty: orderType == 'credit-note' ? (item?.qty > -1 ? item.qty * -1 : item?.qty) : item?.qty < 0 ? item.qty * -1 : item.qty
			}))
		);
	}, [orderType]);

	useEffect(() => {
		if (orderType != 'estimate') {
			if (invItems?.[0]?.qty < 0 && orderType != 'credit-note') {
				setOrderType('credit-note');
			} else if (invItems?.[0]?.qty >= 0 && orderType == 'credit-note') {
				setOrderType('invoice');
			}
		}
	}, [invItems?.[0]?.qty]);

	useEffect(() => {
		if (invItems?.length < 1) {
			setInvItems((oldData) => [{ ...newRowTemplate, expand: true, expandData: newRowTemplate }]);
		}
	}, [invItems]);

	const [invalidData, setInvalidData] = useState(false);
	const [invalidDataMessage, setInvalidDataMessage] = useState('');
	useEffect(() => {
		const invItemsCopy = [...invItems];
		if (invItemsCopy?.length <= 0) {
			setInvalidData(true);
			setInvalidDataMessage('Please add at least one item');
		} else if (invItemsCopy?.some((it) => it.expand)) {
			setInvalidData(true);
			setInvalidDataMessage('Confirm Product details before saving');
		} else if (orderType == 'credit-note' && invItemsCopy?.some((it) => it.qty > -1)) {
			setInvalidData(true);
			setInvalidDataMessage('Credit Note items should have negative quantity');
		} else if (orderType != 'credit-note' && invItemsCopy?.some((it) => it.qty < 1)) {
			setInvalidData(true);
			setInvalidDataMessage('Invoice items should have positive quantity');
		} else if (invItemsCopy?.some((it) => !it.model)) {
			setInvalidData(true);
			setInvalidDataMessage('Please select a model for all items');
		} else if (invItemsCopy?.some((it) => !it.unitPrice)) {
			setInvalidData(true);
			setInvalidDataMessage('Please enter unit price for all items');
		} else if (shippingFee < 0) {
			setInvalidData(true);
			setInvalidDataMessage('Shipping fee should be a positive number');
		} else if (orderType == 'credit-note' && invItemsCopy?.some((it) => !it.invoice)) {
			setInvalidData(true);
			setInvalidDataMessage('Please select an invoice for all items');
		} else {
			setInvalidData(false);
			setInvalidDataMessage('');
		}
	}, [invItems, shippingFee]);

	// ## Handle Quantity Change ## //

	const handleQtyChange = (index, value) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, qty: value } : item)));
	};

	// ## Handle Unit Price Change ## //

	const handleUnitPriceChange = (index, value) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, unitPrice: value } : item)));
	};

	// ## Handle Comment Change ## //

	const handleCommentChange = (index, value) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, comment: value } : item)));
	};

	// ## Handle Add Comment Toggle ## //
	const handleAddCommentToggle = (index, status) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, commentToggle: status } : item)));
	};

	// ## Handle Model Change ## //
	const handleModelChange = (index, e, isCreditModal = false) => {
		if (isCreditModal) {
			const unitPrice = e?.converted_currency_unit_price?.[currency] || 0;
			setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, model: e.value, unitPrice } : item)));
		} else {
			setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, model: e.value } : item)));
		}
	};

	// ## Handle Invoice Change ## //
	const handleInvoiceChange = (index, e) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, invoice: e.value, modelOptionsLoading: true } : item)));

		api.getEstimateProducts(e.value).then((res) => {
			setInvItems((oldData) =>
				oldData.map((item, i) =>
					i === index
						? {
								...item,
								invoice: e.value,
								modelOptionsLoading: false,
								modelOptions: res?.data?.map((r) => ({ ...r, label: r?.product?.product_name, value: r?.product_id })) || []
						  }
						: item
				)
			);
		});
	};

	// ## Handle VAT Change ## //
	const handleVatChange = (index, e) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, vat: e.value } : item)));
	};

	// ## Handle Remove Inv Item ## //
	const handleRemoveInvItem = (index) => {
		setInvItems((oldData) => oldData.filter((item, i) => i != index));
	};

	// ## Handle Shipping Change ## //
	const handleShippingChange = (e) => {
		setShippingFee(e.target.value);
	};

	// ## Handle Toggle Item Expand ## //
	const handleItemExpand = (index) => {
		setInvItems((oldData) =>
			oldData.map((item, i) => (i === index ? { ...item, expand: true, expandData: { ...item } } : { ...item, expand: false }))
		);
	};

	// ## Handle Product Detail Edit Ok ## //
	const handleProductDetailEditOk = (index) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item, expand: false, expandData: null } : item)));
	};

	// ## Handle Product Detail Edit Cancel ## //
	const handleProductDetailEditCancel = (index) => {
		setInvItems((oldData) => oldData.map((item, i) => (i === index ? { ...item?.expandData, expand: false, expandData: null } : item)));
	};

	// ## Handle Add Item ## //
	const handleAddItem = () => {
		setInvItems((oldData) => [...oldData, { ...newRowTemplate, expand: true, expandData: newRowTemplate }]);
	};

	// ## Handle Submit ## //
	const handleSubmit = () => {
		let invItemsCopy = invItems.filter((item) => item.model || item.customValue);
		const preparedData = invItemsCopy.map((item) => ({
			...item,
			model: models?.find((m) => m.value == item.model),
			invoice: invoiceList?.find((inv) => inv.value == item.invoice),
			vat: vatTypes?.find((v) => v.value == item.vat),
			customValue: item.customValue || ''
		}));

		onSubmit &&
			onSubmit({
				invItems: preparedData,
				shippingFee,
				discount,
				selections: {
					invoiceList,
					models
				}
			});
	};

	const subtotal = invItems?.reduce((acc, item) => acc + Number(item?.unitPrice) * Number(item.qty), 0) || 0;
	const discountTotal = discount.discountType == 'percentage' ? (subtotal * discount.discountValue) / 100 : discount.discountValue;
	const total = Number(subtotal) + Number(shippingFee) * Number(shippingQty) - (orderType != 'credit-note' ? discountTotal : 0);


	const [amount, setAmount] = useState(1.0);
	const [fromCurrency, setFromCurrency] = useState('USD');
	const [toCurrency, setToCurrency] = useState('EUR');
	const [result, setResult] = useState(0);
	const [exchangeRate, setExchangeRate] = useState([]);
		const currencyOptions = [
			{ value: 'USD', label: 'USD', image: us },
			{ value: 'EUR', label: 'EUR', image: eu },
			{ value: 'AED', label: 'AED', image: gbp }
		];
		useEffect(() => {
			const today = new Date().toISOString().split('T')[0];
			const cachedExchangeRate = localStorage.getItem('exchangeRate');
			const cacheDate = localStorage.getItem('cacheDate');
	
			if (cachedExchangeRate && cacheDate === today) {
				setExchangeRate(JSON.parse(cachedExchangeRate));
			} else {
				api.getExchangeRate().then((res) => {
					const newExchangeRate = res;
					setExchangeRate(newExchangeRate);
					localStorage.setItem('exchangeRate', JSON.stringify(newExchangeRate));
					localStorage.setItem('cacheDate', today);
				});
			}
		}, []);
	
		useEffect(() => {
			// Convert the exchangeRate array into an object
			const exchangeRateObj = exchangeRate.reduce((acc, curr) => {
				acc[curr.name] = curr.rate;
				return acc;
			}, {});
	
			const baseCurrencyRate = exchangeRateObj[fromCurrency];
			const conversionCurrencyRate = exchangeRateObj[toCurrency];
			const convertedAmount = (amount / baseCurrencyRate) * conversionCurrencyRate;
			setResult(convertedAmount);
		}, [amount, fromCurrency, toCurrency, exchangeRate]);
	
		const handleAmountChange = (event) => {
			setAmount(event.target.value);
		};
	
		const handleFromCurrencyChange = (selectedOption) => {
			setFromCurrency(selectedOption);
		};
	
		const handleToCurrencyChange = (selectedOption) => {
			setToCurrency(selectedOption);
		};
	
		const handleIconClick = () => {
			const temp = fromCurrency;
			setFromCurrency(toCurrency);
			setToCurrency(temp);
		};
	
		const [showExchange, setShowExchange] = useState(false);


	return (
		<div
			className="d-flex"
			style={{
				width: '100dvw',
				height: '100dvh',
				position: 'fixed',
				left: '0',
				top: '0',
				zIndex: '20',
				paddingBottom: '90px',
				justifyContent: 'center',
				alignItems: 'end'
			}}
		>
			<div
				className="popup product-popup-mobile d-md-none"
				ref={compRef}
				style={{ position: 'relative', transform: 'none', top: '0', left: '0', maxWidth: '90%' }}
			>
				<div className="" style={{ display: 'flex', flexDirection: 'column' }}>
					{invItems.map((item, index) => (
						<React.Fragment key={item?.seqId}>
							{!item.expand ? (
								<div
									className=""
									style={{
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'space-between',
										width: '100%',
										borderBottom: '1px solid #eee',
										padding: '8px 15px',
										gap: 10
									}}
									onClick={() => {
										handleItemExpand(index);
									}}
								>
									<div style={{ display: 'flex', flexDirection: 'column', gap: 5, flex: 1 }}>
										<div style={{ fontWeight: 500 }}>
											{orderType == 'credit-note' ? (
												item?.expandData ? (
													<div>
														<p className="m-0 p-0">
															{item?.expandData?.modelOptions?.find((v) => v?.value == item?.expandData.model)?.label || 'None Selected'}
														</p>
														<span style={{ color: 'grey' }}>{invoiceList?.find((v) => v?.value == item?.expandData.invoice)?.label}</span>
													</div>
												) : (
													<div>
														<p className="m-0 p-0">{item?.modelOptions?.find((v) => v?.value == item.model)?.label || 'None Selected'}</p>
														<span style={{ color: 'grey' }}>{invoiceList?.find((v) => v?.value == item.invoice)?.label}</span>
													</div>
												)
											) : item?.expandData ? (
												<div className="d-flex flex-column">
													<p className="m-0 p-0">{models?.find((v) => v?.value == item?.expandData.model)?.label || 'None Selected'}</p>
													<span style={{ color: 'grey' }}>{item?.expandData?.comment}</span>
												</div>
											) : (
												<div className="d-flex flex-column">
													<p className="m-0 p-0">{models?.find((v) => v?.value == item.model)?.label || 'None Selected'}</p>
													<span style={{ color: 'grey' }}>{item?.comment}</span>
												</div>
											)}
										</div>
										<div style={{ display: 'flex', gap: 10, alignItems: 'center', fontSize: 11, color: '#666' }}>
											<div>QTY - {item?.qty}</div> <div>|</div>
											<div>
												Price - {getCurrencySymbol(currency)}&nbsp;
												{numberFormatter.format(item?.unitPrice)}
											</div>
										</div>
										<div style={{ fontWeight: 500 }}>
											{getCurrencySymbol(currency)}&nbsp;
											{numberFormatter.format(Number(item?.unitPrice) * Number(item.qty))}
										</div>
									</div>
									<div>
										<button
											className="new-remove-btn"
											onClick={(e) => {
												e.stopPropagation();
												handleRemoveInvItem(index);
											}}
										>
											<FiTrash2 />
										</button>
									</div>
								</div>
							) : (
								<div
									style={{
										display: 'flex',
										flexDirection: 'column',
										padding: '8px 15px',
										borderBottom: '1px solid #eee',
										width: '100%'
									}}
								>
									{/* {orderType == 'credit-note' && (
										<div className="form-group mb-2">
											<label htmlFor="">Invoice</label>
											<ReactSelect
												className="rs-container"
												classNamePrefix="rs"
												options={[...invoiceList]?.filter((inv) =>
													customer && transitCompany
														? inv?.customer?.id == customer.id && inv?.transit_company?.id == transitCompany.id
														: inv?.customer
														? inv?.customer?.id == customer.id
														: inv?.transit_company
														? inv?.transit_company?.id == transitCompany.id
														: true
												)}
												onChange={(e) => {
													handleInvoiceChange(index, e);
												}}
												value={invoiceList?.find((v) => v?.value == item.invoice)}
												menuPlacement="auto"
												menuPosition="fixed"
											/>
										</div>
									)} */}
									<div
										className="form-group mb-2 flex align-center"
										style={{
											gap: '10px',
										}}
									>
										<div className="text-gray-500" style={{ marginTop: '8px' }}>Model</div>
										{orderType == 'credit-note' ? (
											<ReactSelect
												className="rs-container"
												classNamePrefix="rs"
												options={item.modelOptions}
												onChange={(e) => {
													handleModelChange(index, e, true);
												}}
												value={item?.modelOptions?.find((v) => v?.value == item.model)}
												menuPlacement="auto"
												menuPosition="fixed"
											/>
										) : (
											<ReactSelect
												className="rs-container"
												classNamePrefix="rs"
												options={[...models]?.filter((m) => invItems?.every((it) => it.model != m.value) || m.value == item.model)}
												onChange={(e) => {
													handleModelChange(index, e);
												}}
												value={models?.find((v) => v?.value == item.model)}
												menuPlacement="auto"
												menuPosition="fixed"
											/>
										)}
									</div>
									<div style={{ display: 'flex', gap: 10, justifyContent: 'space-between' }}>
										<div className="form-group mb-2">
											<label htmlFor="">Quantity</label>
											<input
												type="number"
												className="form-control"
												placeholder="0"
												value={item.qty}
												onChange={(e) => {
													handleQtyChange(index, e.target.value);
												}}
												onFocus={(event) => {
													event.target.select();
												}}
											/>
										</div>

										<div className="form-group mb-2">
											<label htmlFor="">VAT</label>
											<ReactSelect
												className="rs-container"
												classNamePrefix="rs"
												options={vatTypes}
												value={vatTypes?.find((v) => v?.value == item.vat)}
												onChange={(e) => {
													handleVatChange(index, e);
												}}
												menuPlacement="auto"
												menuPosition="fixed"
											/>
										</div>
									</div>
									<div className="mb-2" style={{ display: 'flex', gap: 10, justifyContent: 'space-between' }}>
										<div className="form-group mb-2" style={{ width: '42%' }}>
											<label htmlFor="">Price</label>
											<input
												type="number"
												className="form-control"
												value={item.unitPrice}
												onChange={(e) => {
													handleUnitPriceChange(index, e.target.value);
												}}
												onFocus={(event) => {
													event.target.select();
												}}
											/>
										</div>
										<div className="form-group mb-2" style={{ width: '41%' }}>
											<label htmlFor="">Total</label>
											<input
												className="form-control"
												style={{ backgroundColor: '#f5f55', minHeight: 35 }}
												value={`${getCurrencySymbol(currency)} ${numberFormatter.format(Number(item.unitPrice) * Number(item.qty))}`}
												readOnly
											/>
										</div>
										<div className="mb-2" style={{ display: 'flex', alignItems: 'end', paddingBottom: 6 }}>
											<button
												className="new-remove-btn"
												onClick={(e) => {
													e.stopPropagation();
													handleRemoveInvItem(index);
												}}
											>
												<FiTrash2 />
											</button>
										</div>
									</div>
									<div className="d-flex mb-2" style={{ gap: '10px' }}>
										<button
											className="btn btn-outlined-main"
											style={{ flex: '1' }}
											onClick={() => {
												handleProductDetailEditOk(index);
											}}
										>
											OK
										</button>
										<button
											className="btn btn-outlined-main"
											style={{ flex: '1' }}
											onClick={() => {
												handleProductDetailEditCancel(index);
											}}
										>
											Cancel
										</button>
									</div>
								</div>
							)}
						</React.Fragment>
					))}
					{invItems?.every((it) => !it.expand) && (
						<div style={{ borderBottom: '1px solid #eee' }}>
							<button className="mobile-full-primary-btn" onClick={handleAddItem}>
								<FaPlus /> Add Item
							</button>
						</div>
					) }
					<div style={{ marginBottom: 12 }}>
						<button
							type="button"
							onClick={() => setShowExchange((prev) => !prev)}
							style={{
								width: '100%',
								padding: '10px 16px',
								borderRadius: '6px',
								background: '#f0f2f6',
								fontWeight: 500,
								fontSize: 13,
								border: 'none',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'space-between',
								cursor: 'pointer'
							}}
						>
							Currency Exchange
							<div
								style={{
									fontSize: 18,
									transition: 'transform 0.3s',
									transform: showExchange ? 'rotate(180deg)' : 'rotate(0deg)'
								}}
							>
								<FiChevronDown />
							</div>
						</button>
						<AnimatePresence>
							{showExchange && (
								<motion.div
									initial={{ height: 0, opacity: 0 }}
									animate={{ height: 'auto', opacity: 1 }}
									exit={{ height: 0, opacity: 0 }}
									transition={{ duration: 0.3 }}
									style={{
										overflow: 'hidden',
										background: '#f0f2f6'
									}}
								>
									<div style={{ padding: 16 }}>
										<form onSubmit={(event) => event.preventDefault()} style={{ width: '100%', height: '100%' }}>
											<div
												className="form-group"
												style={{ display: 'flex', alignItems: 'center', marginBottom: 5, gap: 10, marginBottom: 10 }}
											>
												<div>Amount</div>
												<input
													type="number"
													step="0.01"
													className="form-control"
													value={amount}
													onChange={handleAmountChange}
													style={{ width: 120 }}
													onWheel={(e) => e.target.blur()}
												/>

												<a>=</a>
												<span className="text-gray-800 fw-600">
													{numberFormatter.format(result)} {toCurrency}
												</span>
											</div>
											<div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
												<Select
													className="custom-form custom-form-1"
													id="fromCurrency"
													value={currencyOptions.find((option) => option.value === fromCurrency)}
													onChange={(selectedOption) => handleFromCurrencyChange(selectedOption.value)}
													options={currencyOptions}
													formatOptionLabel={({ image, label }) => (
														<div>
															<img src={image} height="15px" width="15px" style={{ borderRadius: '50%', marginRight: 5 }} />
															{label}
														</div>
													)}
													styles={{
														control: (provided) => ({
															...provided
														}),
														dropdownIndicator: (provided) => ({
															...provided,
															backgroundColor: 'transparent',
															width: '10px' // Adjust this value as needed
														}),
														indicatorSeparator: () => ({
															display: 'none'
														})
													}}
												/>
												<div>
													<IconArrowsExchange size={20} onClick={handleIconClick} />
												</div>
												<Select
													className="custom-form custom-form-1"
													id="toCurrency"
													value={currencyOptions.find((option) => option.value === toCurrency)}
													onChange={(selectedOption) => handleToCurrencyChange(selectedOption.value)}
													options={currencyOptions}
													formatOptionLabel={({ image, label }) => (
														<div>
															<img src={image} height="15px" width="15px" style={{ borderRadius: '50%', marginRight: 5 }} />
															{label}
														</div>
													)}
													styles={{
														control: (provided) => ({
															...provided
														}),
														dropdownIndicator: (provided) => ({
															...provided,
															backgroundColor: 'transparent',
															width: '10px' // Adjust this value as needed
														}),
														indicatorSeparator: () => ({
															display: 'none'
														})
													}}
												/>
											</div>
										</form>
									</div>
								</motion.div>
							)}
						</AnimatePresence>
					</div>

					<div
						className="mb-2"
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							minHeight: 25.5,
							paddingLeft: 15,
							paddingRight: 15,
							fontSize: '16px'
						}}
					>
						<div>Subtotal</div>
						<div>
							{getCurrencySymbol(currency || 'eur')}&nbsp;{numberFormatter.format(subtotal || 0)}
						</div>
					</div>
					<div
						className="mb-2"
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							paddingLeft: 15,
							paddingRight: 15,
							fontSize: '16px',
						}}
					>
						<div>Shipping</div>
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{getCurrencySymbol(currency || 'eur')}&nbsp;
							<input
								type="number"
								value={shippingFee}
								onChange={handleShippingChange}
								onFocus={(event) => {
									event.target.select();
								}}
								className="mobile-sm-input"
								style={{
									fontSize: '16px',
									width: '100px',
									textAlign: 'right'
								}}
							/>
						</div>
					</div>
					<div
						className="mb-2"
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							paddingLeft: 15,
							paddingRight: 15,
							fontSize: '16px',
						}}
					>
						<select
							value={discount.discountType}
							onChange={(e) => setDiscount({ ...discount, discountType: e.target.value })}
							style={{
								width: '40%',
								padding: '2px 4px',
								border: '1px solid rgb(206, 212, 218)',
								borderRadius: '4px',
								fontSize: '16px',
								backgroundColor: 'rgb(255, 255, 255)',
								boxSizing: 'border-box',
								outline: 'none',
								transition: 'border-color 0.2s',
								minHeight: '0px'
							}}
						>
							<option value="percentage">Percentage</option>
							<option value="amount">Amount</option>
						</select>
						<div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
							{getCurrencySymbol(currency || 'eur')}&nbsp;
							<input
								type="number"
								className="mobile-sm-input"
								value={discount.discountValue}
								onChange={(e) => {
									setDiscount({ ...discount, discountValue: e.target.value });
								}}
								onFocus={(event) => {
									if (event.target.value == '0.00' || event.target.value == '0') {
										setDiscount({ ...discount, discountValue: '' });
									}
									event.target.select();
								}}
								onWheel={(e) => e.target.blur()}
								style={{
									fontSize: '16px',
									width: '100px',
									textAlign: 'right'
								}}
							/>
						</div>
					</div>
					<div
						className="mb-2"
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
							minHeight: 25.5,
							paddingLeft: 15,
							paddingRight: 15,
							fontSize: '16px',
						}}
					>
						<div>Total</div>
						<div>
							{getCurrencySymbol(currency || 'eur')} {numberFormatter.format(total || 0)}
						</div>
					</div>
				</div>

				<div
					className="btnarea"
					style={{
						position: 'sticky',
						bottom: 0,
						left: 0,
						width: '100%',
						background: '#fff',
						padding: '16px 0 12px 0',
						boxShadow: '0 -2px 12px rgba(0,0,0,0.04)',
						zIndex: 30,
						display: 'flex',
						gap: 10,
						justifyContent: 'center'
					}}
				>
					<Tooltip title={invalidData ? invalidDataMessage : null} arrow placement="top">
						<button className="btn btn-main" onClick={handleSubmit} disabled={invalidData}>
							<FaSave /> Save
						</button>
					</Tooltip>
					<button className="btn new-btn-error" onClick={handleClose}>
						<FaTimes /> Close
					</button>
				</div>
			</div>
		</div>
	);
};

export default ProductsPopupMobile;
